module.exports = __webpack_public_path__ + "img/svg/background-login-mobile.b7f1c0c6d668ec326f3103e6c30e4393.svg";